import { c as _c } from "react/compiler-runtime";
import type { SVGProps } from 'react';
const Collapse = props => {
  const $ = _c(21);
  let isExpanded;
  let rest;
  if ($[0] !== props) {
    ({
      isExpanded,
      ...rest
    } = props);
    $[0] = props;
    $[1] = isExpanded;
    $[2] = rest;
  } else {
    isExpanded = $[1];
    rest = $[2];
  }
  const t0 = isExpanded ? "M8 12L5 15" : "M9 11L6 14";
  let t1;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      transition: "d 0.3s ease"
    };
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t0) {
    t2 = <path d={t0} stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" style={t1} />;
    $[4] = t0;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const t3 = isExpanded ? "M5 12H8L7.99994 15" : "M6 11H9L8.99994 14";
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      transition: "d 0.3s ease"
    };
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t3) {
    t5 = <path d={t3} stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" style={t4} />;
    $[7] = t3;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const t6 = isExpanded ? "M12 8L15 5" : "M11 9L14 6";
  let t7;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      transition: "d 0.3s ease"
    };
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== t6) {
    t8 = <path d={t6} stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" style={t7} />;
    $[10] = t6;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  const t9 = isExpanded ? "M15 8H12L12.0001 5" : "M14 9H11L11.0001 6";
  let t10;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = {
      transition: "d 0.3s ease"
    };
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  let t11;
  if ($[13] !== t9) {
    t11 = <path d={t9} stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" style={t10} />;
    $[13] = t9;
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  let t12;
  if ($[15] !== rest || $[16] !== t11 || $[17] !== t2 || $[18] !== t5 || $[19] !== t8) {
    t12 = <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>{t2}{t5}{t8}{t11}</svg>;
    $[15] = rest;
    $[16] = t11;
    $[17] = t2;
    $[18] = t5;
    $[19] = t8;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  return t12;
};
export default Collapse;